<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Carrello</h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-5xl">
      <div class="p-8 -mr-6 -mb-8 flex items-center space-x-4">
        <!-- Campo SKU con larghezza ridotta -->
        <div class="w-1/6">
          <label for="sku" class="block text-sm font-medium text-gray-700">SKU:</label>
          <form @submit.prevent="storeSale()">
            <input id="sku" ref="skuInput" v-model="form.sku"
              class="w-full border rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500" />
          </form>
        </div>

        <!-- Selezione Cliente -->
        <div v-if="cart.length > 0" class="w-5/6 relative">
          <label for="customer_id" class="block text-sm font-medium text-gray-700">Cliente:</label>
          <input type="text" id="customer_id" v-model="searchCustomer"
            placeholder="Cerca cliente (Telefono, Email, Coupon)"
            class="w-full border rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            @input="onSearchCustomersChange" @keyup.enter="confirmCustomer" />

          <!-- Lista Suggerimenti -->
          <ul v-if="searchResults.length" class="absolute bg-white border w-full rounded-md mt-1 shadow-lg z-10">
            <li v-for="customer in searchResults" :key="customer.id" @click="selectCustomer(customer)"
              class="p-2 cursor-pointer hover:bg-gray-100">
              {{ customerLabel(customer) }}
            </li>
          </ul>
        </div>

      </div>
      <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
        <!-- <input ref="input" class="terminal-input" autofocus v-model="message"/>  -->
        <!-- <input v-model="form.sku" :error="form.errors.sku" class="form-input pr-6 pb-3 w-full lg:w-1/3" @keyup.enter="storeSale()" /> -->
        <!-- <StreamBarcodeReader @decode="onDecode" @loaded="onLoaded"></StreamBarcodeReader> -->
        <!-- <select-input v-model="form.batch_id" :error="form.errors.batch_id" class="pr-6 pb-8 w-full lg:w-1/2" label="Lotto">
            <option :value="null" />
            <option v-for="batch in batches" :key="batch.id" :value="batch.id">{{ batch.nome }}</option>
          </select-input> -->
      </div>
      <div class="bg-white rounded-md shadow overflow-x-auto">
        <table class="w-full whitespace-nowrap">
          <tr class="text-left font-bold">
            <th class="px-1 pt-6 pb-3">SKU</th>
            <th class="px-1 pt-6 pb-3">Nome</th>
            <th class="px-1 pt-6 pb-3">Taglia</th>
            <th class="px-1 pt-6 pb-3">Store</th>
            <th class="px-1 pt-6 pb-3">Prezzo</th>
            <th class="px-1 pt-6 pb-3">Sconto</th>
            <th class="px-1 pt-6 pb-3">Prezzo Scontato</th>
            <th class="px-1 pt-6 pb-3">Opzioni</th>
          </tr>
          <tr v-for="item in cart" :key="item.id"
            :class="{ 'bg-red-100': item.pivot.is_return, 'hover:bg-gray-100': !item.pivot.is_return }">
            <td class="border-t px-1">{{ item.sku !== null ? item.sku : item.sku2 }}</td>
            <td class="border-t px-1">{{ item.name }}</td>
            <td class="border-t px-1">{{ item.taglia }}</td>
            <td class="border-t px-1">{{ item.batch && item.batch.organization !== null ? item.batch.organization.name :
              '' }}</td>
            <!-- Colonna Prezzo: mostra il prezzo o un trattino se è un reso -->
            <td class="border-t px-1">
              {{ item.pivot.is_return ? '-' : item.prezzo_unitario.toFixed(2) + ' €' }}
            </td>
            <!-- Colonna Sconto: mostra lo sconto o un trattino se è un reso -->
            <td class="border-t px-1">
              {{ item.pivot.is_return ? '-' : item.pivot.discount + '%' }}
            </td>

            <td class="border-t px-1 py-1">{{ calculateRoundedDiscountedPrice(item).toLocaleString('it-IT', {
              minimumFractionDigits: 2, maximumFractionDigits: 2
            }) }} €</td>
            <td class="border-t px-1">
              <button @click="destroy(item.id)">Elimina</button>
            </td>
          </tr>

          <tr v-for="item in manualItems" :key="item.id" class="bg-yellow-50">
            <td class="border-t px-1">-</td>
            <td class="border-t px-1 text-gray-500 italic">NO CARTELLINO</td>
            <td class="border-t px-1">-</td>
            <td class="border-t px-1">{{ item.store }}</td>
            <td class="border-t px-1">
              <input
                v-model.number="item.prezzo_unitario"
                type="number"
                min="1"
                step="0.01"
                class="border p-1 w-24"
                @input="validateManualPrice(item)"
              />
              <p v-if="item.error" class="text-red-600 text-xs mt-1">{{ item.error }}</p>
            </td>
            <td class="border-t px-1">{{ item.sconto }}%</td>
            <td class="border-t px-1">
              {{
                (item.prezzo_unitario - (item.prezzo_unitario * item.sconto / 100)).toLocaleString('it-IT', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })
              }} €
            </td>
            <td class="border-t px-1">
              <button @click="removeManualItem(item.id)">Elimina</button>
            </td>
          </tr>


          <tr v-if="cart.length === 0">
            <td class="border-t px-1 py-4" colspan="8">Nessun prodotto</td>
          </tr>
        </table>
      </div>
      <pagination class="mt-6" :links="cart" />
      <div class="px-8 py-2 bg-gray-50 flex justify-end items-center space-x-6">
        <div class="text-sm text-gray-700">
          📦 <strong>{{ totalItemCount }}</strong> prodotto/i totali (inclusi resi)
        </div>
        <div class="text-sm text-gray-700">
          🛒 <strong>{{ cartItemCount }}</strong> prodotto/i nel carrello
        </div>
        <div class="text-sm text-gray-700" v-if="returnItemCount > 0">
          🔁 <strong>{{ returnItemCount }}</strong> prodotto/i in reso
        </div>
      </div>
      <div class="px-8 py-2 bg-gray-50 flex justify-end items-center">
        <h3 class="mb-1 font-bold text-1xl">
          Totale: € {{ total.toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
        </h3>

        <!-- 🔥 Mostra lo sconto personalizzato se esiste -->
        <span v-if="customerDiscount" class="ml-4 px-3 py-1 bg-green-100 text-green-800 text-sm font-semibold rounded">
          Sconto Cliente: {{ customerDiscount }}%
        </span>
      </div>

      <!-- <div v-if="cart.length > 6" class="px-8 py-2 bg-gray-50 flex justify-end items-center">
        <input type="checkbox" v-model="isEmployee" id="isEmployee" class="mr-2" />
        <label for="isEmployee">Sconto Extra</label>
      </div> -->
      <div v-if="(cart.length > 0 || manualItems.length > 0) && adjustedMinDiscount !== null"
        class="px-8 py-2 bg-gray-50 border-t border-gray-100">
        <div class="flex flex-col space-y-2 text-right">
          <h1 class="mb-1 font-bold text-2xl">
            Totale con {{ adjustedMinDiscount }}%: €
            {{ totalDiscounted.toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
          </h1>
        </div>
      </div>
      <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
        <button class="btn-gray mr-4" @click="addManualItem">
          + NO CARTELLINO
        </button>
        <button class="btn-indigo" @click="store()">Crea Vendita</button>
      </div>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import { StreamBarcodeReader } from 'vue-barcode-reader'
import Icon from '@/Shared/Icon'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import Multiselect from 'vue-multiselect'

export default {
  metaInfo: { title: 'Crea Vendita' },
  components: {
    LoadingButton,
    SelectInput,
    StreamBarcodeReader,
    TextInput,
    Icon,
    Pagination,
    SearchFilter,
    Multiselect,
  },
  layout: Layout,
  props: {
    batches: Array,
    userOrganizationDiscount: {
      type: Number,
      default: 0
    },
    userOrganizationName: {
      type: String,
      default: '—'
    },
    customers: {
      type: Array,
      default: () => []
    },
    selectedCustomer: {
      type: Object,
      default: () => null
    },
    cart: Array,
    error: String,
  },
  remember: 'form',
  data() {
    return {
      manualItems: [],
      searchCustomer: this.$page.props.selectedCustomer
        ? this.customerLabel(this.$page.props.selectedCustomer)
        : "", // 🔥 Se c'è un cliente salvato, mostra il nome nel campo
      searchResults: [], // 🔥 Per la ricerca
      form: this.$inertia.form({
        sku: null,
        selectedCustomer: this.$page.props.selectedCustomer || null, // Recupera il cliente dal backend
        customer_id: this.$page.props.selectedCustomer?.id || null,
      }),
      isEmployee: false,
    }
  },
  mounted() {
    // 🔥 Se il backend non ha più un cliente selezionato, rimuovilo anche nel frontend
    if (!this.$page.props.selectedCustomer) {
      this.form.selectedCustomer = null;
      this.form.customer_id = null;
    }
  },
  methods: {
    validateManualPrice(item) {
      if (item.prezzo_unitario <= 0) {
        item.error = "Il prezzo deve essere maggiore di 0.";
        item.prezzo_unitario = null
      } else {
        item.error = null;
      }
    },
    addManualItem() {
      const sconto = Math.max(this.userOrganizationDiscount, this.customerDiscount ?? 0); // o solo this.userOrganizationDiscount se vuoi

      this.manualItems.push({
        id: 'manual-' + Date.now(),
        prezzo_unitario: 1,
        sconto: sconto,
        quantity: 1,
        store: this.userOrganizationName,
      });
    },

    removeManualItem(id) {
      this.manualItems = this.manualItems.filter(item => item.id !== id);
    },

    calculateRoundedDiscountedPrice(item) {
      // 🔁 Se reso → negativo
      if (item.pivot.is_return && item.sale) {
        return -item.sale.price;
      }

      const discount = item.pivot.discount ?? 0;
      const discounted = item.prezzo_unitario - (item.prezzo_unitario * discount / 100);

      return discounted;
    },

    async onSearchCustomersChange() {
      if (this.searchCustomer.length < 5) {
        this.searchResults = [];
        return;
      }

      try {
        const response = await fetch(this.route('cart.searchCustomers') + '?term=' + this.searchCustomer);
        this.searchResults = await response.json();
      } catch (error) {
        console.error('Errore durante la ricerca clienti:', error);
      }
    },

    selectCustomer(customer) {
      this.form.customer_id = customer.id;
      this.form.selectedCustomer = customer;
      this.searchCustomer = this.customerLabel(customer); // 🔥 Mostra il cliente selezionato nel campo input
      this.searchResults = [];

      // 🔥 Invia il cliente selezionato al backend per salvarlo su user_cart
      this.$inertia.post(this.route('cart.setCustomer'), { customer_id: customer.id });

      // 🔥 Dopo aver selezionato il cliente, riporta il focus sul campo SKU
      this.$nextTick(() => {
        this.$refs.skuInput.focus();
      });
    },

    confirmCustomer() {
      if (this.searchResults.length > 0) {
        this.selectCustomer(this.searchResults[0]); // 🔥 Seleziona il primo cliente trovato
      }
    },

    customerLabel({ phone, email, coupon, points }) {
      let label = "";
      if (coupon) label += `Code: ${coupon}`;
      label += ` | ⭐ Punti: ${points}`;
      return label;
    },

    onEnter() {
      console.log('pressed enter')
    },
    storeSale() {
      if (navigator.onLine) {
        this.form.post(this.route('cart.store')), this.form.reset('sku');
      } else {
        this.$page.props.flash.error = 'Controllare la connessione e ricaricare la pagina'
      }
    },

    store() {
      if (navigator.onLine) {
        const payload = {
          sku: this.form.sku,
          customer_id: this.form.customer_id,
          manualItems: this.manualItems,
        };

        this.form.post(this.route('order.store', payload), {
          onSuccess: () => {
            this.form.sku = "";
            this.isEmployee = false;
            // 🔥 Rimuove il cliente dopo la vendita
            this.form.selectedCustomer = null;
            this.form.customer_id = null;
            this.searchCustomer = "";
            this.manualItems = [];

            // 🔥 Riporta il focus sul campo SKU
            this.$nextTick(() => {
              this.$refs.skuInput.focus();
            });
          }
        });
      } else {
        this.$page.props.flash.error = 'Controllare la connessione e ricaricare la pagina';
      }
    },

    destroy(id) {
      if (navigator.onLine) {
        this.form.delete(this.route('cart.destroy', id))
      } else {
        this.$page.props.flash.error = 'Controllare la connessione e ricaricare la pagina'
      }
    },
    onDecode(text) {
      console.log(`Decode text from QR code is ${text}`)
    },
    onLoaded() {
      console.log(`Ready to start scanning barcodes`)
    },
  },
  computed: {
    totalItemCount() {
      const cartCount = this.cart.reduce((total, item) => total + item.pivot.quantity, 0);
      const manualCount = this.manualItems.reduce((total, item) => total + (item.quantity || 1), 0);
      return cartCount + manualCount;
    },
    cartItemCount() {
      const realProducts = this.cart.reduce((total, item) => {
        return !item.pivot.is_return ? total + item.pivot.quantity : total;
      }, 0);

      const manualCount = this.manualItems.reduce((total, item) => total + (item.quantity || 1), 0);
      return realProducts + manualCount;
    },
    returnItemCount() {
      return this.cart.reduce((total, item) => {
        return item.pivot.is_return ? total + item.pivot.quantity : total;
      }, 0);
    },
    customerDiscount() {
      // 🔥 Se il cliente ha uno sconto personalizzato, usiamolo
      return this.selectedCustomer && this.selectedCustomer.discount
        ? parseInt(this.selectedCustomer.discount) // Converte lo sconto in numero
        : null;
    },

    adjustedMinDiscount() {
      return this.isEmployee
        ? 70
        : Math.max(this.userOrganizationDiscount ?? 0, this.customerDiscount ?? 0);
    },

    total() {
      let sum = 0;

      // Articoli normali (non resi)
      this.cart.forEach(item => {
        if (!item.pivot.is_return) {
          sum += item.prezzo_unitario * item.pivot.quantity;
        } else {
          sum += this.calculateRoundedDiscountedPrice(item) * item.pivot.quantity;
        }
      });

      // Articoli manuali (senza sconto)
      this.manualItems.forEach(item => {
        sum += item.prezzo_unitario * item.quantity;
      });

      return sum;
    },
    totalDiscounted() {
      let sum = 0;

      // Articoli normali
      this.cart.forEach(item => {
        sum += this.calculateRoundedDiscountedPrice(item) * item.pivot.quantity;
      });

      // Articoli manuali con sconto
      this.manualItems.forEach(item => {
        const discounted = item.prezzo_unitario - (item.prezzo_unitario * item.sconto / 100);
        sum += discounted * item.quantity;
      });

      return sum;
    },


  },
}
</script>
